module.exports = __webpack_public_path__ + "img/标题4.d8e946b7.png";